import {ClientSwitcher} from "../ClientSwitcher";
import type {SwitcherClient} from "../ClientSwitcher";
import {GoToMenu} from "./GoToMenu.tsx";
import type {GoToItemId} from "./utils";

interface PartnerClientToolbarProps {
    clients: SwitcherClient[];
    selectedClientId: string | null;
    recentClientIds: string[];
    goToItemIds: GoToItemId[];
    onSelectClient: (clientId: string | null) => void;
}

export function PartnerClientToolbar({clients, selectedClientId, recentClientIds, goToItemIds, onSelectClient}: PartnerClientToolbarProps) {
    return (
        <div className="flex items-center gap-2">
            <ClientSwitcher
                clients={clients}
                selectedClientId={selectedClientId}
                recentClientIds={recentClientIds}
                onSelect={onSelectClient}
            />
            <GoToMenu clientId={selectedClientId} visibleItemIds={goToItemIds}/>
        </div>
    );
}
